import { useFormContext, useWatch } from 'react-hook-form';
import CheckboxRow from '@/components/UI/CheckboxRow';
import Text from '@/components/Unistyles/Text';
import Card from '../UI/Card';
import type { EventEditFormValues } from './EventEdit.types';

function EventEditInputStandings() {
  const { setValue, control } = useFormContext<EventEditFormValues>();
  const hasStandings = useWatch({
    name: 'hasStandings',
    control,
  });
  const onChangeHasStandings = (nextHasStandings: boolean) => {
    setValue('hasStandings', nextHasStandings, {
      shouldDirty: true,
    });
  };
  return (
    <Card>
      <CheckboxRow
        value={!!hasStandings}
        onValueChange={onChangeHasStandings}
        variant="success"
      >
        <Text bold>Track standings for this season.</Text>
      </CheckboxRow>
    </Card>
  );
}
export default EventEditInputStandings;
